<template>
  <div>
    <v-layout class="mb-2">
      <h2 class="ma-0 pt-1 subheading font-weight-bold">
        Информация о товаре
      </h2>
      <v-btn
        class="mt-1 mb-0 mx-2 plus-button"
        :disabled="!canEdit || disabledAddItem"
        @click="addItem"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mt-1 mb-0 mx-2 plus-button"
            :disabled="!canEdit || disabledAddItem || selectedItemIds.length === 0"
            @click="copyItem"
            v-on="on"
          >
            <v-icon>content_copy</v-icon>
          </v-btn>
        </template>
        <span>Создать на основаниии строки</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <ImportItemsDialog
              :goods-details-id="goodsDetailsId"
              :disabled="!canEdit || disabledAddItem"
              @import="
                () => {
                  $emit('getItems');
                }
              "
            />
          </span>
        </template>
        <span>Загрузить</span>
      </v-tooltip>

      <CalculateWeight
        param="netto"
        :disabled="!canEdit || selectedItemIds.length === 0"
        @change="changeWeightNetto"
      />
      <CalculateWeight
        param="brutto"
        :disabled="!canEdit || selectedItemIds.length === 0"
        @change="changeWeightBrutto"
      />

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-badge
            right
            :color="!canEdit || selectedItemIds.length === 0 ? 'grey' : 'secondary'"
            class="bulk-badge"
          >
            <template v-slot:badge>
              <span>М</span>
            </template>
            <v-btn
              small
              icon
              class="mt-1 mb-0 mx-2"
              :disabled="!canEdit || selectedItemIds.length === 0"
              v-on="on"
              @click="bulkFactoryMarkingDialog = true"
            >
              <v-icon>archive</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Массовое заполнение параметра "Маркировка"</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-badge
            right
            :color="!canEdit || selectedItemIds.length === 0 ? 'grey' : 'secondary'"
            class="bulk-badge"
          >
            <template v-slot:badge>
              <span>ТК</span>
            </template>
            <v-btn
              small
              icon
              class="mt-1 mb-0 mx-2"
              :disabled="!canEdit || selectedItemIds.length === 0"
              v-on="on"
              @click="bulkCustomsNumberDialog = true"
            >
              <v-icon>archive</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Массовое заполнение параметра "Таможенный код"</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-badge
            right
            :color="!canEdit || selectedItemIds.length === 0 ? 'grey' : 'secondary'"
            class="bulk-badge"
          >
            <template v-slot:badge>
              <span>К</span>
            </template>
            <v-btn
              small
              icon
              class="mt-1 mb-0 mx-2"
              :disabled="!canEdit || selectedItemIds.length === 0"
              v-on="on"
              @click="bulkProductCategoryDialog = true"
            >
              <v-icon>archive</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Массовое заполнение параметра "Категория"</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            icon
            class="mt-1 mb-0 mx-2"
            :disabled="!canEdit || selectedItemIds.length === 0"
            v-on="on"
            @click="confirmDialog = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>Удалить строки</span>
      </v-tooltip>

      <v-spacer />
      <ColumnsSettingsGoodsItems
        :columns="columns"
        resource="goodsDetailsItems"
        :settings-button-style="{
          flat: true,
          colorButton: '',
          colorIcon: 'grey'
        }"
        @change="updateColumns"
      />
      <v-btn
        small
        icon
        class="mr-0"
        :disabled="loading"
        @click="$emit('changeCompactMode')"
      >
        <v-icon>{{ compactMode ? "fullscreen" : "fullscreen_exit" }}</v-icon>
      </v-btn>
    </v-layout>

    <GoodDetailBulkDialog
      :visible="bulkFactoryMarkingDialog"
      @onUpdate="handleUpdateFactoryMarking"
      @onClose="closeBulkFactoryMarkingDialog"
    />
    <GoodDetailBulkDialog
      :visible="bulkCustomsNumberDialog"
      @onUpdate="handleUpdateCustomsNumber"
      @onClose="closeBulkCustomsNumberDialog"
    />
    <GoodDetailBulkCategoryDialog
      :visible="bulkProductCategoryDialog"
      @onUpdate="handleUpdateProductCategory"
      @onClose="closeBulkProductCategoryDialog"
    />

    <v-dialog
      v-if="itemEditor"
      v-model="itemEditorDialog"
      persistent
      width="1100"
    >
      <v-card>
        <v-card-text>
          <ItemEditor
            :value="editedItem"
            :is-editor-item-open="itemEditor"
            @change="handleItemChange"
            @changeCatalogValue="handleItemChangeWithChangesCatalogs"
            @cancel="closeItemEditor"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="catalogsChangeConfirmDialog"
      persistent
      width="1100"
    >
      <v-card>
        <v-card-text>
          <h1 class="headline mb-2">
            Значения отличаются от каталожных
          </h1>
          <v-data-table
            class="mb-3"
            :headers="changesTableHeader"
            :items="changesTableItems"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr v-if="props.item.Materials.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.MaterialToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Материал</td>
                <td>{{ props.item.Materials[0] }}</td>
                <td>{{ props.item.Materials[1] }}</td>
              </tr>
              <tr v-if="props.item.Sizes.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.SizeToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Размеры</td>
                <td>{{ props.item.Sizes[0] }}</td>
                <td>{{ props.item.Sizes[1] }}</td>
              </tr>
              <tr v-if="props.item.GoodSites.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.GoodSiteToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Сайт товара</td>
                <td>{{ props.item.GoodSites[0] }}</td>
                <td>{{ props.item.GoodSites[1] }}</td>
              </tr>
              <tr v-if="props.item.Countries.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.CountryToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Страна</td>
                <td>{{ props.item.Countries[0].Title }}</td>
                <td>{{ props.item.Countries[1].Title }}</td>
              </tr>
              <tr v-if="props.item.ProductCategories.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.ProductCategoryToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Категория</td>
                <td>{{ props.item.ProductCategories[0].Title }}</td>
                <td>{{ props.item.ProductCategories[1].Title }}</td>
              </tr>
              <tr v-if="props.item.Units.length > 0">
                <td>
                  <v-checkbox
                    v-model="props.item.UnitToChange"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                  />
                </td>
                <td>Ед. изм.</td>
                <td>{{ props.item.Units[0].Title }}</td>
                <td>{{ props.item.Units[1].Title }}</td>
              </tr>
              <tr v-if="props.item.Units.length > 0">
                <td>
                  <v-checkbox
                    v-model="allChangesCheck"
                    class="layout align-center justify-center row fill-height changes-checkbox"
                    @change="allChangesCheckChange"
                  />
                </td>
                <td colspan="2">
                  {{ allChangesCheck ? "Отменить все" : "Выбрать все" }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            color="primary"
            @click="saveChanges"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-action-confirm
      :value="confirmDialog"
      text="Вы действительно хотите удалить выделенные строки описания?"
      @cancel="confirmDialog = false"
      @confirm="removeItems"
    />

    <div class="v-table__overflow">
      <div
        class="v-data-table theme--light v-data-table--fixed-header v-data-table--fixed-footer"
      >
        <div
          id="visible-items"
          class="v-data-table__wrapper"
          :style="{
            height: blockHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'auto'
          }"
        >
          <table class="v-datatable v-table theme--light">
            <thead>
              <slot name="header">
                <tr>
                  <th class="fixed-column">
                    <v-checkbox
                      v-model="selectedAllItems"
                      class="layout align-center justify-center row fill-height changes-checkbox ml-1"
                      @change="selectAllItems"
                    />
                  </th>
                  <th
                    v-for="header in visibleColumns"
                    :key="header.title"
                    :style="{
                      maxWidth: header.width ? `${header.width}px` : 'auto',
                      whiteSpace: header.width ? 'normal' : 'nowrap'
                    }"
                  >
                    <template v-if="header.cellFiltering">
                      <v-layout>
                        <span>{{ header.title }}</span>
                        <CellFilter
                          :value="filter[header.name]"
                          :items="items"
                          :label="header.title"
                          :resource="header.name"
                          @change="changeCellFilter"
                        />
                      </v-layout>
                    </template>
                    <template v-else>
                      <span>{{ header.title }}</span>
                    </template>
                  </th>
                </tr>
              </slot>

              <DataTableProgressLine
                v-if="loading || loadingVisibleItems"
                :items-length="headers.length"
              />
            </thead>
            <tbody>
              <template v-for="(item, index) in flatItems">
                <GoodsDetailsItemRow
                  :key="item.id"
                  :columns="visibleColumns"
                  :value="item"
                  :order="index + 1"
                  :disabled="!canEdit"
                  :selected="selectedItemIds.includes(item.id)"
                  @select="selectItem"
                  @change="handleItemChange"
                >
                  <template v-slot:prepend-cell>
                    <MenuRowActions
                      :list="filteredRowActions"
                      :value="item"
                      :index="items.indexOf(item)"
                      :last-index="items.length - 1"
                      class="text-xs-right"
                      @moveUp="moveUp"
                      @moveDown="moveDown"
                      @editItem="editItem"
                      @removeItem="openRowDialog(item)"
                    />
                    <v-dialog
                      v-model="rowDialog"
                      persistent
                      width="350"
                    >
                      <v-card>
                        <v-card-title>
                          Вы действительно хотите удалить строку?
                        </v-card-title>
                        <v-card-actions>
                          <v-layout
                            align-center
                            justify-end
                          >
                            <v-btn
                              small
                              flat
                              color="primary"
                              @click="deleteItem"
                            >
                              Ок
                            </v-btn>
                            <v-btn
                              small
                              flat
                              @click="rowDialog = false"
                            >
                              Нет
                            </v-btn>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </GoodsDetailsItemRow>
              </template>
            </tbody>
            <tfoot>
              <slot name="footer">
                <tr>
                  <td />
                  <td
                    v-for="footer in visibleFooters"
                    :key="footer.name"
                    class="footer-table-cell text-nowrap"
                  >
                    {{ footer.value }}
                  </td>
                </tr>
                <td
                  v-for="footer in visibleFooters"
                  :key="footer.name"
                  class="footer-table-cell text-nowrap"
                >
                  <DecimalEditor
                    v-if="footer.name === 'places'"
                    v-model="totalCargoPlacesFact"
                    label="Факт"
                    style="width: 55px"
                    class="mt-1"
                    :disabled="!canEdit"
                    @input="$emit('updatePlacesFact', totalCargoPlacesFact)"
                  />
                </td>
              </slot>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import arrayMove from "array-move";
import ItemEditor from "./GoodsDetailItemEditor.vue";
import CellFilter from "../../../components/CellFilter.vue";
import CalculateWeight from "./CalculateWeight.vue";
import ColumnsSettingsGoodsItems from "./ColumnsSettingsGoodsItems.vue";
import * as goodsDetailsApi from "../../../backend/goodsDetailsApi.js";
import GoodsDetailsItemRow from "./GoodsDetailsItemRow.vue";
import ImportItemsDialog from "../components/ImportItemsDialog.vue";
import DataTableProgressLine from "../../../components/DataTableProgressLine.vue";
import goodsDetailsItemsHeaders from "../components/goods-details-items-headers.js";
import GoodDetailBulkDialog from "./GoodDetailBulkDialog.vue";
import GoodDetailBulkCategoryDialog from "./GoodDetailBulkCategoryDialog.vue";

export default {
  components: {
    ItemEditor,
    CellFilter,
    CalculateWeight,
    ColumnsSettingsGoodsItems,
    GoodsDetailsItemRow,
    ImportItemsDialog,
    DataTableProgressLine,
    GoodDetailBulkDialog,
    GoodDetailBulkCategoryDialog,
  },
  props: [
    "value",
    "canEdit",
    "totalInfo",
    "loading",
    "blockHeight",
    "compactMode",
    "placesFact",
    "goodsDetailsId",
    "disabledAddItem",
  ],
  data() {
    return {
      headers: goodsDetailsItemsHeaders,
      items: [],
      itemEditorDialog: false,
      itemEditor: false,
      editedItem: null,
      scale: 3,
      catalogsChangeConfirmDialog: false,
      changesTableHeader: [
        {
          text: "Сохранить в каталоге",
          sortable: false,
          align: "left",
          width: "20",
        },
        { text: "Наименование", sortable: false, align: "left" },
        { text: "Текущее", sortable: false, align: "left" },
        { text: "Измененное", sortable: false, align: "left" },
      ],
      changesTableItems: [],
      modifiedItem: null,
      allChangesCheck: true,
      filter: {},
      templateItems: [],
      selectedItemIds: [],
      copyItemDialog: false,
      rowCopyIndex: null,
      rowBulkIndex: null,
      rowBulkValue: null,
      rowDialog: false,
      totalCargoPlacesFact: null,
      editableRowItem: null,
      columns: [],
      visibleItems: [],
      loadingVisibleItems: false,
      confirmDialog: false,
      bulkFactoryMarkingDialog: false,
      bulkCustomsNumberDialog: false,
      bulkProductCategoryDialog: false,
    };
  },
  computed: {
    selectedAllItems() {
      return this.selectedItemIds.length === this.visibleItems.length;
    },
    rowActions() {
      if (this.items.length > 1) {
        return [
          {
            title: "Вверх",
            name: "moveUp",
            action: this.moveUp,
            type: "icon",
            icon: "arrow_upward",
            disabled: !this.canEdit,
          },
          {
            title: "Вниз",
            name: "moveDown",
            action: this.moveDown,
            type: "icon",
            icon: "arrow_downward",
            disabled: !this.canEdit,
          },
          {
            title: "Изменить",
            name: "editItem",
            action: this.editItem,
            type: "icon",
            icon: "edit",
            disabled: !this.canEdit,
          },
          {
            title: "Удалить",
            name: "removeItem",
            action: this.removeItem,
            type: "icon",
            icon: "delete",
            disabled: !this.canEdit,
          },
        ];
      } else {
        return [
          {
            title: "Изменить",
            name: "editItem",
            action: this.editItem,
            type: "icon",
            icon: "edit",
            disabled: !this.canEdit,
          },
          {
            title: "Удалить",
            name: "removeItem",
            action: this.removeItem,
            type: "icon",
            icon: "delete",
            disabled: !this.canEdit,
          },
        ];
      }
    },
    filteredRowActions() {
      return this.rowActions.map(r => {
        return {
          title: r.title,
          name: r.name,
          type: r.type,
          icon: r.icon,
          disabled: r.disabled,
        };
      });
    },
    flatItems() {
      return this.visibleItems.map(item => {
        const result = { ...item };
        result.visible = true;
        return result;
      });
    },
    visibleColumns() {
      const visibleColumns = this.columns.filter(c => c.visible);
      visibleColumns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return visibleColumns;
    },
    itemsHeight() {
      if (this.compactMode) {
        return 94;
      } else {
        return 100;
      }
    },
    footers() {
      const footers = this.columns.map(h => {
        const item = {
          name: h.name,
          order: 0,
          visible: true,
        };
        if (item.name === "quantity") {
          item.value = this.totalInfo?.totalQuantity || 0;
        }
        if (item.name === "cost") {
          item.value = this.$options.filters.separateDigits(
            this.totalInfo?.totalCost.toFixed(2).replace(".", ",") || 0,
          );
        }
        if (item.name === "weightNetto") {
          item.value = this.$options.filters.separateDigits(
            this.totalInfo?.totalWeightNetto
              .toFixed(this.scale)
              .replace(".", ",") || 0,
          );
        }
        if (item.name === "weightBrutto") {
          item.value = this.$options.filters.separateDigits(
            this.totalInfo?.totalWeightBrutto
              .toFixed(this.scale)
              .replace(".", ",") || 0,
          );
        }
        if (item.name === "places") {
          item.value = this.totalInfo?.totalCargoPlaces || 0;
        }
        if (item.name === "volume") {
          item.value = this.$options.filters.separateDigits(
            this.totalInfo?.totalVolume.toFixed(this.scale).replace(".", ",") ||
              0,
          );
        }
        return item;
      });
      return footers;
    },
    visibleFooters() {
      const footers = this.footers;
      footers.forEach(f => {
        this.columns.forEach(h => {
          if (h.name === f.name) {
            f.visible = h.visible;
          }
        });
      });
      const visibleFooters = footers.filter(f => f.visible);
      visibleFooters.forEach(f => {
        this.visibleColumns.forEach(c => {
          if (c.name === f.name) {
            f.order = c.order;
          }
        });
      });
      visibleFooters.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.footers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.footers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return visibleFooters;
    },
  },
  watch: {
    value: {
      handler() {
        this.value.forEach(item => (item.index = this.value.indexOf(item) + 1));
        this.items = this.value;
      },
      immediate: true,
      deep: true,
    },
    items: {
      handler(value) {
        this.templateItems = value;
      },
      immediate: true,
      deep: true,
    },
    placesFact: {
      handler(value) {
        this.totalCargoPlacesFact = value;
      },
      immediate: true,
    },
    templateItems() {
      this.getVisibleItems();
    },
  },
  mounted() {
    const itemRow = document.querySelector("#visible-items");
    itemRow.addEventListener("scroll", () => {
      if (itemRow.scrollTop + itemRow.clientHeight >= itemRow.scrollHeight) {
        this.getVisibleItems();
      }
    });
  },
  created() {
    this.initfilter();
    this.setColumns();
  },
  methods: {
    getVisibleItems(isFilterChanged) {
      if (isFilterChanged) {
        this.visibleItems = [];
      }
      if (
        this.visibleItems.length === this.templateItems.length &&
        JSON.stringify(this.visibleItems) === JSON.stringify(this.templateItems)
      ) {
        return;
      } else if (
        (this.visibleItems.length === this.templateItems.length ||
          this.visibleItems.length !== this.templateItems.length) &&
        JSON.stringify(this.visibleItems) !== JSON.stringify(this.templateItems)
      ) {
        this.visibleItems = [];
        this.visibleItems = [...this.templateItems];
        return;
      }
      const diff = this.templateItems.length - this.visibleItems.length;
      const length =
        diff < 10 ? this.templateItems.length : this.visibleItems.length + 10;
      this.loadingVisibleItems = true;
      setTimeout(() => {
        for (let i = this.visibleItems.length; i < length; i++) {
          this.visibleItems.push(this.templateItems[i]);
        }
        this.loadingVisibleItems = false;
      }, 500);
    },
    addItem() {
      this.editedItem = this.createItem();
      this.showItemEditor();
    },
    moveUp(item) {
      let from = null;
      this.items.find((i, index) => {
        if (i.id === item.id) {
          from = index;
        }
      });
      const to = from === 0 ? 0 : from - 1;
      this.items = arrayMove(this.items, from, to);
      this.$emit("moveItems", this.items, item.id, to);
    },
    moveDown(item) {
      let from = null;
      this.items.find((i, index) => {
        if (i.id === item.id) {
          from = index;
        }
      });
      const to = from + 1;
      this.items = arrayMove(this.items, from, to);
      this.$emit("moveItems", this.items, item.id, to);
    },
    editItem(item) {
      this.editedItem = item;
      this.showItemEditor();
    },
    deleteItem() {
      this.items.splice(this.editableRowItem.index - 1, 1);
      this.$emit("deleteItem", this.editableRowItem.id);
      this.rowDialog = false;
    },
    showItemEditor() {
      this.itemEditor = true;
      setTimeout(() => {
        this.itemEditorDialog = true;
      }, 100);
    },
    closeItemEditor() {
      this.itemEditorDialog = false;
      setTimeout(() => {
        this.itemEditor = false;
        this.editedItem = null;
      }, 200);
    },
    handleItemChange(itemUpdate) {
      const element = this.items.find(i => {
        return i.id === itemUpdate.id;
      });
      if (element) {
        this.$emit("update", itemUpdate);
      } else {
        this.items.push(itemUpdate);
        this.$emit("addItem", itemUpdate);
      }
      this.closeItemEditor();
      this.changesTableItems = [];
    },
    handleItemChangeWithChangesCatalogs(data) {
      this.closeItemEditor();
      this.changesTableItems.push(data.changeInfo);
      this.modifiedItem = data.item;
      this.catalogsChangeConfirmDialog = true;
    },
    async saveChanges() {
      if (this.allChangesCheck) {
        var changesInfo = {
          articleId: this.modifiedItem.article
            ? this.modifiedItem.article.id
            : null,
          modelId: this.modifiedItem.model ? this.modifiedItem.model.id : null,
          nomenclatureId: this.modifiedItem.nomenclature
            ? this.modifiedItem.nomenclature.id
            : null,
          changes: this.changesTableItems[0],
        };

        await goodsDetailsApi.saveItems(changesInfo);

        this.catalogsChangeConfirmDialog = false;
        this.handleItemChange(this.modifiedItem);
        this.showInfo("Новые значения добавлены в справочники");
      } else {
        this.catalogsChangeConfirmDialog = false;
        this.handleItemChange(this.modifiedItem);
      }
    },
    allChangesCheckChange() {
      this.changesTableItems[0].MaterialToChange = this.allChangesCheck;
      this.changesTableItems[0].SizeToChange = this.allChangesCheck;
      this.changesTableItems[0].GoodSiteToChange = this.allChangesCheck;
      this.changesTableItems[0].CountryToChange = this.allChangesCheck;
      this.changesTableItems[0].ProductCategoryToChange = this.allChangesCheck;
      this.changesTableItems[0].UnitToChange = this.allChangesCheck;
    },
    createItem() {
      const emptyObj = { id: 0, title: "" };
      let manufacturer = { ...emptyObj };
      let trademark = { ...emptyObj };
      let country = { ...emptyObj };
      if (this.items.length) {
        manufacturer = { ...this.items[this.items.length - 1].manufacturer };
        trademark = { ...this.items[this.items.length - 1].trademark };
        country = { ...this.items[this.items.length - 1].country };
      }

      return {
        id: 0,
        article: { ...emptyObj },
        country,
        manufacturer,
        model: { ...emptyObj },
        nomenclature: { ...emptyObj },
        trademark,
        unit: { ...emptyObj },
        factoryMarking: "",
        goodSite: "",
        material: "",
        fragile: false,
        places: 0,
        quantity: 0,
        weightBrutto: 0,
        weightNetto: 0,
        volume: 0,
        size: "",
        cost: 0,
        customsNumber: "",
        productCategory: { ...emptyObj },
        notes: "",
      };
    },
    initfilter() {
      this.filter = {
        article: [],
        nomenclature: [],
      };
    },
    applyFilter(value) {
      this.getFilterItems(value);
    },
    getFilterItems(value) {
      this.filter = value;
      this.templateItems = this.items.filter(item => {
        return (
          (this.filter?.article.length > 0
            ? this.filter.article.find(a => a.id === item.article?.id)
            : true) &&
          (this.filter?.nomenclature.length > 0
            ? this.filter.nomenclature.find(n => n.id === item.nomenclature?.id)
            : true)
        );
      });
      this.getVisibleItems(true);
    },
    changeCellFilter(value) {
      this.filter[value.resource] = value.filter;
      this.applyFilter(this.filter);
    },
    async changeWeightBrutto(weight) {
      this.loadingVisibleItems = true;

      await goodsDetailsApi.bulkBruttoWeightUpdate(this.selectedItemIds, weight);
      this.$emit("getItems");

      this.loadingVisibleItems = false;
    },
    async changeWeightNetto(weight) {
      this.loadingVisibleItems = true;

      await goodsDetailsApi.bulkBruttoWeightUpdate(this.selectedItemIds, undefined, weight);
      this.$emit("getItems");

      this.loadingVisibleItems = false;
    },
    copyItem() {
      const items = this.items.filter(item => this.selectedItemIds.includes(item.id)).map(item => ({ ...item, id: 0 }));
      this.items.push(...items);
      this.$emit("addItem", items);
      this.closeCopyItemDialog();
    },
    closeCopyItemDialog() {
      this.copyItemDialog = false;
      this.rowCopyIndex = null;
    },
    async handleUpdateFactoryMarking(value) {
      await goodsDetailsApi.bulkUpdate(
        this.selectedItemIds,
        {
          goodDetailsId: Number(this.goodsDetailsId),
          factoryMarking: value
        }
      );
      this.$emit("getItems");

      this.closeBulkFactoryMarkingDialog();
    },
    async handleUpdateCustomsNumber(value) {
      await goodsDetailsApi.bulkUpdate(
        this.selectedItemIds,
        {
          goodDetailsId: Number(this.goodsDetailsId),
          customsNumber: value
        }
      );
      this.$emit("getItems");

      this.closeBulkCustomsNumberDialog();
    },
    async handleUpdateProductCategory(value) {
      await goodsDetailsApi.bulkUpdate(
        this.selectedItemIds,
        {
          goodDetailsId: Number(this.goodsDetailsId),
          productCategoryId: value
        }
      );
      this.$emit("getItems");

      this.closeBulkProductCategoryDialog();
    },
    closeBulkFactoryMarkingDialog() {
      this.bulkFactoryMarkingDialog = false;
    },
    closeBulkCustomsNumberDialog() {
      this.bulkCustomsNumberDialog = false;
    },
    closeBulkProductCategoryDialog() {
      this.bulkProductCategoryDialog = false;
    },
    selectItem(id) {
      if (this.selectedItemIds.includes(id)) {
        this.selectedItemIds = this.selectedItemIds.filter(i => i !== id);
      } else {
        this.selectedItemIds.push(id);
      }
    },
    openRowDialog(item) {
      this.rowDialog = true;
      this.editableRowItem = { ...item };
    },
    setColumns() {
      this.columns = this.headers.map(h => {
        const column = { ...h };
        column.visible = true;
        column.order = 0;
        return column;
      });
    },
    updateColumns(settings) {
      settings.forEach(s => {
        this.columns.forEach(h => {
          if (s.name === h.name) {
            h.visible = s.visible;
            h.order = s.order;
          }
        });
      });
    },
    async removeItems() {
      this.loadingVisibleItems = true;

      await goodsDetailsApi.bulkDelete(this.selectedItemIds, this.goodsDetailsId);
      this.$emit("getItems");

      this.selectedItemIds = [];
      this.confirmDialog = false;
      this.loadingVisibleItems = false;
    },
    selectAllItems() {
      if (this.selectedAllItems) {
        this.selectedItemIds = [];
      } else {
        this.selectedItemIds = this.visibleItems.map(i => i.id);
      }
    },
  },
};
</script>

<style>
.v-select__slot input {
  font-size: 14px;
}
.icon-reveal {
  display: block;
}
.changes-checkbox {
  height: 20px;
}
.changes-checkbox .v-input__control {
  height: 23px;
}
.formating-cell-text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  white-space: nowrap;
}

.bulk-badge > span {
  top: -2px !important;
  right: 2px !important;
  pointer-events: none;
  font-size: 9px;
  height: 18px;
  width: 18px;
}

.fixed-column {
  background: #fff;
  left: 0;
  position: sticky;
  z-index: 1 !important;
}
th.fixed-column {
  z-index: 3 !important;
}

.text-nowrap {
  white-space: nowrap;
}
</style>
